export default {
    PAUSE_MODE: 'Pause Mode',
    FLEX_PUFF: 'Flex Puff',
    FLEX_BATTERY: 'Flex Battery',
    USAGE: 'Usage',
    SOFTWARE_UPDATE: 'Software Update',
    LOW_PERFORMANCE: 'Low Performance',
    LOYALTY: 'Loyalty',
    LOYALTY_BADGES: 'Loyalty Badges',
    CONVERSION_BADGE: 'Conversion Badge',
    EXPERIENCE_COACH: 'Experience Coach',
    NOTIFICATIONS: 'Notifications',
    HOME: 'Home',
    CONTACT_US: 'Contact us',
    VISIT_STORES: 'Visit Stores',
    END_FEEDBACK: 'End Feedback',
};
